import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex wrap g0" }
const _hoisted_2 = {
  class: "header-text",
  style: {"width":"150px"}
}
const _hoisted_3 = { style: {"font-size":"15px"} }
const _hoisted_4 = {
  class: "header-text",
  style: {"width":"350px"}
}
const _hoisted_5 = { style: {"font-size":"15px"} }
const _hoisted_6 = {
  key: 0,
  class: "header-text no-mobile",
  style: {"width":"200px"}
}
const _hoisted_7 = { class: "flex align-center justify-center" }
const _hoisted_8 = {
  key: 0,
  class: "text-red bold"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TaskStatus = _resolveComponent("TaskStatus")!
  const _component_OilResultRow = _resolveComponent("OilResultRow")!
  const _component_SeTable = _resolveComponent("SeTable")!
  const _component_PostponedTaskRow = _resolveComponent("PostponedTaskRow")!
  const _component_SeExpendable = _resolveComponent("SeExpendable")!

  return (_openBlock(), _createBlock(_component_SeExpendable, { headerSize: 20 }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", _hoisted_2, [
          _createElementVNode("b", _hoisted_3, _toDisplayString(_ctx.DateUtils.formatDateWithTime(
                _ctx.TaskManager.getDisplayDate(_ctx.taskWrapper.task!)
              )), 1)
        ]),
        _createElementVNode("span", _hoisted_4, [
          _createElementVNode("b", _hoisted_5, _toDisplayString(_ctx.taskWrapper.task!.name), 1)
        ]),
        (_ctx.taskWrapper.task.employee != null)
          ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.taskWrapper.task!.employee?.name) + " " + _toDisplayString(_ctx.taskWrapper.task!.employee?.surname), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_7, [
        (
            _ctx.taskWrapper.results.every(
              (x) => x.temperature == null && x.polarity == null
            )
          )
          ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.Lang.getI18N("not-taken")), 1))
          : _createCommentVNode("", true),
        _createVNode(_component_TaskStatus, {
          task: _ctx.taskWrapper.task
        }, null, 8, ["task"])
      ])
    ]),
    default: _withCtx(() => [
      (_ctx.taskWrapper.task?.postponed_task == null)
        ? (_openBlock(), _createBlock(_component_SeTable, {
            key: 0,
            widths: [10, 5, 10, 10, 10, 15, 15],
            columns: [
        'Nom element',
        'Image',
        'Équipement nettoyé',
        'Huile changée',
        'Huile filtrée',
        'Filtre changé',
        'Polarité',
        'Température',
        'Photos',
      ]
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.taskWrapper.results, (result) => {
                return (_openBlock(), _createBlock(_component_OilResultRow, { result: result }, null, 8, ["result"]))
              }), 256))
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_SeTable, {
            key: 1,
            widths: [5, 5, 5],
            columns: [
        _ctx.Lang.getI18N('postpone-date'),
        _ctx.Lang.getI18N('period'),
        _ctx.Lang.getI18N('employee'),
      ]
          }, {
            default: _withCtx(() => [
              _createVNode(_component_PostponedTaskRow, {
                task: _ctx.taskWrapper.task
              }, null, 8, ["task"])
            ]),
            _: 1
          }, 8, ["columns"]))
    ]),
    _: 1
  }))
}